import { InjectionToken } from '@angular/core';

export const PIPELINER_NG_UI_THEME = new InjectionToken<NG_UI_THEMES>('PipelinerNgUiTheme');
export type NG_UI_THEMES = 'pipeliner' | 'fabric' | 'material';
